import React from 'react'
import Kids from './Kids'
import Header from './Header'

const App = () => (
  <div>
    <Header />
    <Kids />
  </div>
)

export default App